<template>
  <div>
    <OrderHeader
      :hasPermission="hasPermission"
      @switchTab="switchSubTab"
      :activeTabProp="activeSubTab"
      :viewFilter="viewFilter"
      :toggleProductFilter="toggleProductFilter"
      :refreshOrder="refreshOrder"
      :refreshCancel="refreshCancel"
    />
    <div v-if="activeSubTab === 'orders'">
      <OrderTable
        :orders="orders"
        :hasPermission="hasPermission"
        :loading="loading"
        :details="details"
        :viewFulfillment="viewFulfillment"
        :viewCancel="viewCancel"
        :systemSettings="systemSettings"
        :confirmDelete="confirmDelete"
        :manageAddRecord="manageAddRecord"
      />
      <Pagination
        :limit="pageSize"
        :count="pageCount"
        :page="page"
        :itemsCount="count"
        @changePage="gotoPage"
        @changeLimit="changeLimit"
      />
    </div>
    <div v-if="activeSubTab === 'cancelled'">
      <cancelled
        :isLoading="isLoading"
        :cancelledOrders="cancelledOrders"
        :hasPermission="hasPermission"
        :viewCancellationReason="viewCancellationReason"
        :viewCancelOrder="viewCancelOrder"
        :cancelRequest="cancelRequest"
        :cancelCount="cancelCount"
        :cancelGotoPage="cancelGotoPage"
        :cancelChangeLimit="cancelChangeLimit"
        :changeLimit="changeLimit"
        :cancelPageCount="cancelPageCount"
        :cancelPageSize="cancelPageSize"
        :cancelPage="cancelPage"
      />
    </div>
    <div v-if="activeSubTab === 'product'">
      <productSales ref="productSales" />
    </div>
    <div class="modal fade py-1" id="mod-reason-view" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[##f8f8f8]">
          <div
            class="modal-header bg-transparent flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[10px]"
            >
              Cancellation Reason
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[4px]">
              <h5 class="font-bold text-[16px] leading-[20px] text-[#353535]">
                Customer:
              </h5>
              <p
                class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px]"
              >
                {{ cancellationReason }}
              </p>
            </div>
            <div v-if="distributorCancellationReason">
              <h5 class="font-bold text-[16px] leading-[20px] text-[#353535]">
                Response:
              </h5>
              <p
                class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px]"
              >
                {{ distributorCancellationReason }}
              </p>
            </div>
          </div>
          <div class="flex justify-end">
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] max-w-[150px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-cancel" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-body m-0 p-0">
            <div>
              <h4
                class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
              >
                Reject
              </h4>
              <div class="mt-[10px]">
                <div>
                  <label
                    class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                    for="cancelR"
                    >Reason for rejecting:</label
                  >
                </div>
                <div>
                  <textarea
                    id="cancelR"
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none"
                    name="reason"
                    placeholder="Enter Reason"
                    rows="4"
                    cols="50"
                    v-model="rejectReason"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="cancelRequest(rejectingOrderId, 'rejected')"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Done</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-fulfillment" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header bg-transparent flex items-start justify-between p-0 m-0"
          >
            <h3
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[10px]"
            >
              Fulfillment for order # {{ fOrder.orderNumber }}
            </h3>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]" v-if="fOrder.wasFulfilled == 'true'">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Fulfilled on</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none"
                  :class="[{ 'is-invalid': v1.dateFulfilled }]"
                  type="date"
                  :max="maxDate"
                  placeholder="Select a date"
                  v-model="fOrder.dateFulfilled"
                />

                <ul v-if="v1.dateFulfilled" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div>
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Notes</label
              >
              <div>
                <textarea
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none"
                  :class="[{ 'is-invalid': v1.notes }]"
                  v-model="fOrder.notes"
                ></textarea>
                <ul v-if="v1.notes" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="fulfillment"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-cancel-order" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header bg-transparent flex items-start justify-between p-0 m-0"
          >
            <h3
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[10px]"
            >
              Cancel order # {{ fOrder.orderNumber }}
            </h3>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Notes</label
              >
              <div>
                <textarea
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none"
                  :class="[{ 'is-invalid': v2.notes }]"
                  v-model="fOrder.notes"
                ></textarea>
                <ul v-if="v2.notes" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="cancelOrder"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-order-fulfillment-status"
      data-backdrop="static"
      data-keyboard="false"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title">
              Order Status Has Been Updated To FulFilled
            </h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div class="col-12">
                <p style="font-size: small; color: gray; text-align: center">
                  See inventory movement summary below
                </p>
                <ul>
                  <li v-for="o in inventoryMovementSummary" :key="o">
                    {{ o }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-primary"
              type="button"
              data-dismiss="modal"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- filter modal -->
    <div class="modal fade" id="mod-filter" role="dialog" tabindex="-1">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h3
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h3>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <div class="pb-[24px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >By Status</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Orders</option>
                  <option value="pending">Pending</option>
                  <option value="fulfilled">Fulfilled</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Date Start</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.dateStart"
              />
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Date End</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.dateEnd"
              />
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Buyer Name</label
              >
              <div class="">
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by buyer name..."
                  v-model="filter.maker"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Order Number</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by order number..."
                  v-model="filter.orderNumber"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getOrders"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <vue-confirm-dialog></vue-confirm-dialog>
    <div v-if="isActive">{{ modal.actionText }}</div>
    <Modal
      :orderData="order"
      @proceed="updateOrderStatus($event)"
      :isBusy="modal.isLoading"
      :text="modal.actionText"
      :message="modal.message"
    />
    <GeneralDeleteCaution
      :id="deleteId"
      @proceed="deleteOrder"
      :isBusy="isBusyModal"
      text="order"
    />
    <RecordPayment
      :value="singleOrder"
      :isEdit="isEdit"
      :editDetails="editDetails"
      @getOrder="getOrders"
      @reset="resetEdit"
      @closeModal="closePaymentRecord"
    />
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import moment from "moment";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import Modal from "../components/helpers/modal.vue";
import RecordPayment from "../components/Order/RecordPayment.vue";
import Pagination from "../components/Pagination.vue";
import OrderHeader from "../components/ManageOrders/OrderHeader.vue";
import OrderTable from "../components/ManageOrders/OrderTable.vue";
import cancelled from "../components/ManageOrders/cancelled.vue";
import productSales from "../components/ManageOrders/productSales.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "ordersRecieved",
  components: {
    Select2,
    Modal,
    GeneralDeleteCaution,
    Pagination,
    RecordPayment,
    OrderHeader,
    OrderTable,
    cancelled,
    productSales,
  },

  mounted() {
    window.setInterval(() => {
      this.getOrders();
    }, 300000);
    this.maxDate = helper.preventFutureDateSelection();
    this.getCancelledOrders();
  },

  created() {
    if (!this.hasPermission("Orders_View")) {
      this.$router.push("/restricted");
    }
    if (this.hasPermission("Orders_View")) {
      this.activeSubTab = "orders";
    } else if (this.hasPermission("Inventory_Reconcile_Stock_View")) {
      this.activeSubTab = "product";
    } else {
      this.activeSubTab = "cancelled";
    }

    var user = this.$store.state.currentUser;
    if (this.hasPermission("Global_View_Orders")) {
      this.isGlobal = true;
    } else {
      this.isGlobal = false;
    }
    var startDate = this.$route.query.sd
      ? this.$route.query.sd
      : moment()
          // .subtract(13, "days")
          .format("1999-01-01");
    var endDate = this.$route.query.ed
      ? this.$route.query.ed
      : moment().format("YYYY-MM-DD");
    var status = this.$route.query.st ? this.$route.query.st : "0";
    var buyerName = this.$route.query.bn ? this.$route.query.bn : "";
    var orderNumber = this.$route.query.on ? this.$route.query.on : "";
    var myOrderOnly =
      this.$route.query.mo && this.$route.query.mo == "true" ? true : false;

    this.filter = {
      status: status,
      orderNumber: orderNumber,
      maker: buyerName,
      dateStart: moment(String(startDate)).format("YYYY-MM-DD"),
      dateEnd: moment(String(endDate)).format("YYYY-MM-DD"),
      showForMe: myOrderOnly,
    };

    this.getOrders();

    if (this.user.type === "Distributor") this.getSystemSettings();
  },

  data() {
    return {
      fetchDate: Date.now(),
      activeSubTab: null,
      loadingNewOrders: false,
      filter: {
        status: "0",
        orderNumber: "",
        maker: "",
        dateStart: moment().format("1999-01-01"),
        dateEnd: moment().format("YYYY-MM-DD"),
        showForMe: false,
      },
      isGlobal: false,
      isBusy: false,
      isBusyModal: false,
      fOrder: {},
      inventoryMovementSummary: {},
      v1: {
        wasFulfilled: false,
        dateFulfilled: false,
        notes: false,
      },
      v2: {
        notes: false,
      },
      orders: [],
      cancelledOrders: [],
      deleteId: "",
      createdUser: {},
      singleOrder: {},
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      cancelCount: 0,
      cancelPage: 1,
      cancelPageSize: 10,
      cancelPageCount: 0,
      cancelHasNext: false,
      cancelHasPrev: false,
      cancelStatus: "",
      cancellationReason: "",
      distributorCancellationReason: "",
      rejectReason: "",
      rejectingOrderId: "",
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
      systemSettings: {},
      isEdit: false,
      editDetails: {},
      maxDate: "",
      order: {
        orderId: "",
        status: "",
      },
      isActive: true,
      modal: {
        isLoading: false,
        actionMethod: "",
        actionText: "",
        message: "",
      },
      loading: true,
      isLoading: true,
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  methods: {
    refreshOrder() {
      this.getOrders();
    },
    refreshCancel() {
      this.getCancelledOrders();
    },
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    toggleProductFilter() {
      if (this.$refs.productSales) {
        this.$refs.productSales.toggleFilter();
      }
    },
    reset() {
      this.filter = {
        status: "0",
        orderNumber: "",
        maker: "",
        dateStart: moment()
          // .subtract(13, "days")
          .format("1999-01-01"),
        dateEnd: moment().format("YYYY-MM-DD"),
        showForMe: false,
      };
    },

    openModal(btnText, message) {
      this.modal.actionText = btnText;
      this.modal.message = message;
      $("#modal").modal("show");
    },

    closeModal() {
      this.modal.actionText = "";
      this.modal.message = "";
      $("#modal").modal("hide");
    },

    confirmOrder(id) {
      this.order.orderId = id;
      this.order.status = "Confirmed";
      this.openModal("Confirm", "Confirm this order");
    },
    dispatchOrder(id) {
      this.order.orderId = id;
      this.order.status = "Dispatched";
      this.openModal("Dispatch", "Dispatch this order");
    },
    recallDelivery(id) {
      this.order.orderId = id;
      this.order.status = "recallDelivery";
      this.openModal("Recall Delivery", "Recall this order from dispatch");
    },
    markAsDelivered(id) {
      this.order.orderId = id;
      this.order.status = "markAsDelivered";
      this.openModal("Mark As Delivered", "Mark this order as delivered");
    },

    declineOrder(id) {
      this.order.orderId = id;
      this.order.status = "Cancel";
      this.openModal("Decline", "Decline this order");
    },

    confirmDelete(id) {
      this.deleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    cancelConfirm() {
      this.deleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },

    // gotoAnyPage(page) {
    //   this.$router.push(page);
    // },

    async deleteOrder() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(`/Orders/${this.deleteId}`);
        if (res.ok) {
          this.$toast.success("Order deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getOrders();
          this.cancelConfirm();
        }
      } catch (error) {}
      this.isBusyModal = false;
    },

    async refresh() {
      try {
        this.isBusy = true;
        this.loadingNewOrders = true;

        const prevDate = this.fetchDate;
        await this.$http
          .get(
            "/Orders/getList?page=" +
              this.page +
              "&pageSize=" +
              this.pageSize +
              (this.filter.orderNumber != ""
                ? "&orderNumber=" + this.filter.orderNumber
                : "") +
              (this.filter.maker != "" ? "&buyer=" + this.filter.maker : "") +
              (this.filter.status != "0"
                ? "&status=" + this.filter.status
                : "") +
              (this.filter.dateStart != ""
                ? "&dateStart=" +
                  moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
                : "") +
              (this.filter.dateEnd != ""
                ? "&dateEnd=" +
                  moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
                : "") +
              (!this.isGlobal ? "&sellerId=" + this.user.parentId : "") +
              this.user.parentId +
              (this.filter.showForMe != ""
                ? "&showForMe=" + this.filter.showForMe
                : "")
          )
          .then(function(res) {
            this.orders = res.body.data;
            this.page = res.body.page;
            this.pageSize = res.body.pageSize;
            this.count = res.body.count;
            this.hasPrev = res.body.hasPrev;
            this.hasNext = res.body.hasNext;
            this.isBusy = false;
            this.fetchDate = Date.now();

            let newOrdersCount = 0;

            this.orders.forEach((element) => {
              if (
                new Date(element.created).getTime() >
                new Date(prevDate).getTime()
              ) {
                newOrdersCount++;
              }
            });

            this.loadingNewOrders = false;

            if (newOrdersCount > 0) {
              this.$toast.success(
                `${newOrdersCount} New Order${newOrdersCount > 1 ? "s" : ""}`,
                {
                  icon: false,
                  rtl: false,
                }
              );
            } else {
              this.getOrders();
              this.$toast("No New Orders", {
                icon: false,
                rtl: false,
              });
            }
          });
      } catch (error) {
        this.loadingNewOrders = false;
        this.isBusy = false;
      }
    },

    viewFulfillment(o) {
      this.v1 = {
        notes: false,
        wasFulfilled: false,
        dateFulfilled: false,
      };
      this.fOrder = {
        orderId: o.id,
        orderNumber: o.orderNumber,
        wasFulfilled: true,
        notes: null,
        dateFulfilled: moment().format("YYYY-MM-DD"),
        updateStatusOnly: false,
      };
      $("#mod-fulfillment").modal("show");
    },
    viewCancellationReason(reason, distributorReason) {
      this.cancellationReason = reason;
      this.distributorCancellationReason = distributorReason;

      $("#mod-reason-view").modal("show");
    },

    viewCancel(o) {
      this.v2 = {
        notes: false,
      };
      this.fOrder = {
        orderId: o.id,
        orderNumber: o.orderNumber,
        wasFulfilled: false,
        notes: null,
        dateFulfilled: moment().format("YYYY-MM-DD"),
      };

      $("#mod-cancel-order").modal("show");
    },

    viewExport() {
      // $("#mod-export").modal("show");
    },

    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },

    details(id) {
      // console.log(id);
      // this.$router.push(
      //   "/orders/" +
      //     id +
      //     "?sd=" +
      //     this.filter.dateStart +
      //     "&ed=" +
      //     this.filter.dateEnd +
      //     "&st=" +
      //     this.filter.status +
      //     "&bn=" +
      //     this.filter.maker +
      //     "&on=" +
      //     this.filter.orderNumber +
      //     "&mo=" +
      //     this.filter.showForMe
      // );
    },

    async updateOrderStatus(data) {
      this.isBusy = true;
      try {
        const res = await this.$http.post("/Orders/updateOrderStatus", data);
        if (res.ok) {
          // console.log(res.body);
          this.$toast.success(res.body, {
            icon: true,
            rtl: false,
          });
          this.getOrders();
          this.cancelConfirm();
          this.isBusy = false;
          this.closeModal();
        }
      } catch (error) {
        this.$toast.error(res.error, {
          icon: true,
          rtl: false,
        });
      }
    },

    async getOrders() {
      this.isBusy = true;
      this.loading = true;
      this.orders = {};
      await this.$http
        .get(
          "/Orders/getList?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            (this.filter.orderNumber != ""
              ? "&orderNumber=" + this.filter.orderNumber
              : "") +
            (this.filter.maker != "" ? "&buyer=" + this.filter.maker : "") +
            (this.filter.status != "0" ? "&status=" + this.filter.status : "") +
            (this.filter.dateStart != ""
              ? "&dateStart=" +
                moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter.dateEnd != ""
              ? "&dateEnd=" +
                moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
              : "") +
            "&sellerId=" +
            this.user.parentId +
            "&showForMe=" +
            !this.isGlobal
        )
        .then(function(res) {
          this.orders = res.body.data;
          this.page = res.body.pageNumber;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
          this.loading = false;
          this.fetchDate = Date.now();
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    async getCancelledOrders() {
      this.isBusy = true;
      this.isLoading = true;
      await this.$http
        .get(
          "/Orders/getDistributorCancelList?page=" +
            this.cancelPage +
            "&pageSize=" +
            this.cancelPageSize +
            "&distributorId=" +
            this.user.parentId +
            "&cancelStatus=" +
            this.cancelStatus
        )
        .then(function(res) {
          this.cancelledOrders = res.body.data;
          this.cancelPage = res.body.page;
          this.cancelPageSize = res.body.pageSize;
          this.cancelCount = res.body.count;
          this.cancelHasPrev = res.body.hasPrev;
          this.cancelHasNext = res.body.hasNext;
          this.cancelPageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
          this.isLoading = false;
          this.fetchDate = Date.now();
        })
        .catch(function() {
          this.isLoading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    validate() {
      this.v1 = {
        notes: false,
        wasFulfilled: false,
        dateFulfilled: false,
      };
      var isValid = true;

      if (!this.fOrder.dateFulfilled && this.fOrder.wasFulfilled == "true") {
        this.v1.dateFulfilled = true;
        isValid = false;
      }

      if (!this.fOrder.wasFulfilled) {
        this.v1.wasFulfilled = true;
        isValid = false;
      }

      if (!this.fOrder.notes) {
        this.v1.notes = true;
        isValid = false;
      }

      return isValid;
    },
    async fulfillment() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validate()) {
        var message = "";
        if (this.systemSettings.autoOrderFulfillmentReconciliation) {
          message =
            "Order status will be updated to fulfilled and inventory will be depleted. Please confirm";
        } else {
          message =
            "Only Order status will be updated to fulfilled. Please confirm";
        }

        let self = this;
        this.$confirm(
          //Vue.$vueConfirm.confirm(
          {
            auth: false,
            message: message,
            button: {
              no: "Cancel",
              yes: "Proceed",
            },
            callback: (confirm) => {
              if (confirm) {
                $("#mod-fulfillment").modal("hide");

                self.$http
                  .post("/Orders/fulfillment", self.fOrder)
                  .then(function(res) {
                    if (res.body.responseCode == "00") {
                      self.isBusyModal = false;
                      self.getOrders();
                    } else if (res.body.responseCode == "01") {
                      self.isBusyModal = false;
                      self.getOrders();
                      self.inventoryMovementSummary =
                        res.body.inventoryMovementSummary;
                      $("#mod-order-fulfillment-status").modal("show");
                    } else if (res.body.responseCode == "999X") {
                      self.$confirm({
                        auth: false,
                        message: res.body.responseDescription,
                        button: {
                          no: "Cancel",
                          yes: "Proceed",
                        },
                        callback: (confirm) => {
                          if (confirm) {
                            self.fOrder.updateStatusOnly = true;
                            self.$http
                              .post("/Orders/fulfillment", self.fOrder)
                              .then(function(res) {
                                self.isBusyModal = false;
                                self.getOrders();
                              })
                              .catch(function() {
                                self.isBusy = false;
                                self.isBusyModal = false;
                              });
                          }
                        },
                      });
                    } else {
                      self.getOrders();
                    }
                  })
                  .catch(function() {
                    self.isBusy = false;
                    self.isBusyModal = false;
                  });
              }
            },
          }
        );
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    async cancelOrder() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateCancel()) {
        $("#mod-cancel-order").modal("hide");
        try {
          const res = await this.$http.post("/Orders/fulfillment", this.fOrder);
          this.isBusyModal = false;
          this.getOrders();
        } catch (err) {
          this.isBusy = false;
          this.isBusyModal = false;
        }
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    validateCancel() {
      this.v2 = {
        notes: false,
      };
      var isValid = true;

      if (!this.fOrder.notes) {
        this.v2.notes = true;
        isValid = false;
      }

      return isValid;
    },

    async getSystemSettings() {
      this.isBusy = true;

      await this.$http
        .get(`/SystemSettings/getByAccount?parentId=${this.user.parentId}`)
        .then(function(res) {
          this.systemSettings = res.body;
          this.isBusy = false;
        })
        .catch(function() {});

      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("lll");
    },

    prev() {
      this.page -= 1;
      this.getOrders();
    },

    next() {
      this.page += 1;
      this.getOrders();
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },
    async displayNameForUser(id) {
      var result = "";

      await this.$http
        .get("/Users/getById/" + id)
        .then((response) => response.json())
        .then((data) => {
          result = data["displayName"];
          return result;
        })
        .catch((error) => {
          // console.log(error);
        });
      return result;
    },
    goToPayment(id) {
      this.$router.push("/payments/" + id);
    },
    toggleGlobal() {
      $("#mod-global").modal("hide");
      this.isGlobal = !this.isGlobal;

      this.$auth.setPreferredViewForOrder(
        this.isGlobal ? "global" : "default",
        this.user.id
      );

      this.getOrders();
    },
    gotoPage(page) {
      this.page = page;
      this.getOrders();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 1;
      this.getOrders();
    },

    cancelGotoPage(page) {
      this.cancelPage = page;
      this.getCancelledOrders();
    },

    cancelChangeLimit(limit) {
      this.cancelPageSize = limit;
      this.cancelPage = 1;
      this.getCancelledOrders();
    },

    closePaymentRecord() {
      $("#mod-add-payment-record").modal("hide");
    },

    addPaymentRecord() {
      $("#mod-add-payment-record").modal("show");
    },

    manageAddRecord(id) {
      const order = this.orders.find((el) => el.id === id);
      this.singleOrder = order;
      this.addPaymentRecord();
    },

    resetEdit() {
      this.editDetails = {};
      this.isEdit = false;
    },

    viewCancelOrder(id) {
      this.isBusyModal = false;
      this.rejectingOrderId = id;
      $("#mod-cancel").modal("show");
    },

    async cancelRequest(id, type) {
      this.isBusyModal = true;
      let data = {
        orderId: id,
        cancellationStatus: type,
        cancellationReason: type === "accepted" ? "" : this.rejectReason,
      };

      await this.$http
        .post("/Orders/updateCancellationStatus", data)
        .then(function(res) {
          this.isBusyModal = false;
          this.getOrders();
          this.getCancelledOrders();
          this.rejectReason = "";
        })
        .catch(function() {
          this.isBusy = false;
          this.isBusyModal = false;
        });

      $("#mod-cancel").modal("hide");
    },
  },
};
</script>
